<div data-testid="sales-request-page" class="p-6">
  <div class="mb-6 flex justify-between items-center">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ "distribution.sales_request.title" | translate }}
    </h2>
    @if (canCreate()) {
      <p-button
        data-testid="sales-request-add-btn"
        icon="pi pi-plus"
        [label]="'common.actions.new' | translate"
        (onClick)="onAdd()"
      />
    }
  </div>

  <div class="mb-4 flex flex-wrap items-end gap-3">
    <input
      pInputText
      data-testid="sales-request-series-filter"
      [(ngModel)]="series"
      [placeholder]="'distribution.fields.series' | translate"
      (keyup.enter)="onSearch()"
    />
    <input
      pInputText
      data-testid="sales-request-title-filter"
      [(ngModel)]="title"
      [placeholder]="'distribution.fields.title' | translate"
      (keyup.enter)="onSearch()"
    />
    <p-select
      data-testid="sales-request-status-filter"
      [options]="statusOptions"
      [(ngModel)]="status"
      optionValue="value"
      [showClear]="true"
      appendTo="body"
      [placeholder]="'distribution.fields.status' | translate"
    >
      <ng-template let-option pTemplate="item">
        {{ option.label | translate }}
      </ng-template>
      <ng-template let-option pTemplate="selectedItem">
        {{ option.label | translate }}
      </ng-template>
    </p-select>
    <p-button
      icon="pi pi-search"
      [label]="'common.actions.search' | translate"
      (onClick)="onSearch()"
    />
    <p-button
      severity="secondary"
      [outlined]="true"
      [label]="'common.actions.reset' | translate"
      (onClick)="onReset()"
    />
  </div>

  <p-table
    data-testid="sales-request-table"
    [value]="rows()"
    [lazy]="true"
    (onLazyLoad)="onLazyLoad($event)"
    [paginator]="true"
    [rows]="pageSize"
    [first]="first()"
    [totalRecords]="total()"
    [loading]="loading()"
    [showCurrentPageReport]="true"
    [currentPageReportTemplate]="
      'common.table.pagination.current_page_report' | translate
    "
    dataKey="id"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>{{ "distribution.fields.series" | translate }}</th>
        <th>{{ "distribution.fields.title" | translate }}</th>
        <th>{{ "distribution.fields.schedule_date" | translate }}</th>
        <th>{{ "distribution.fields.status" | translate }}</th>
        <th>{{ "distribution.fields.sales_orders" | translate }}</th>
        <th>{{ "distribution.fields.created_at" | translate }}</th>
        <th>{{ "common.table.columns.actions" | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row.series }}</td>
        <td>{{ row.title }}</td>
        <td>{{ row.scheduleDate | date: "dd/MM/yyyy" }}</td>
        <td>
          @if (row.status) {
            <p-tag
              [value]="'distribution.status.request.' + row.status | translate"
              [severity]="statusSeverity(row.status)"
            />
          }
        </td>
        <td>
          @for (soId of row.salesOrderIds ?? []; track soId) {
            <a
              class="text-blue-600 underline mr-2"
              [href]="'/distribution/sales-order/view/' + soId"
              >#{{ soId }}</a
            >
          } @empty {
            <span class="text-gray-400">-</span>
          }
        </td>
        <td>{{ row.creationDate | date: "dd/MM/yyyy HH:mm" }}</td>
        <td>
          <div class="inline-flex items-center gap-3 whitespace-nowrap">
            <button
              type="button"
              class="cursor-pointer text-blue-600"
              [attr.data-testid]="'sales-request-view-' + row.id"
              (click)="onView(row)"
            >
              {{ "common.actions.view" | translate }}
            </button>
            @if (row.status === "PENDING" && canApprove()) {
              <button
                type="button"
                class="cursor-pointer text-green-600"
                [attr.data-testid]="'sales-request-approve-' + row.id"
                (click)="onApprove(row)"
              >
                {{ "common.actions.approve" | translate }}
              </button>
            }
            @if (row.status !== "APPROVED" && canDelete()) {
              <button
                type="button"
                class="cursor-pointer text-red-600"
                [attr.data-testid]="'sales-request-delete-' + row.id"
                (click)="onDelete(row)"
              >
                {{ "common.actions.delete" | translate }}
              </button>
            }
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center text-gray-500">
          {{ "common.table.no_data_message" | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog
  [acceptLabel]="'common.actions.confirm' | translate"
  [rejectLabel]="'common.actions.cancel' | translate"
/>
<p-toast />
